import {
  BookOpen,
  Camera,
  ChefHat,
  Clapperboard,
  Code2,
  Dumbbell,
  Gamepad2,
  HeartHandshake,
  Mountain,
  Music,
  Music2,
  Palette,
  PersonStanding,
  Shirt,
  Sparkles,
  Trophy,
  Tv,
  type LucideIcon,
} from "lucide-react";
import type { MentorInterestOption } from "@/lib/mentor-profile/constants";

export const INTEREST_ICONS = {
  Music,
  Gaming: Gamepad2,
  "Art & drawing": Palette,
  Sports: Trophy,
  Reading: BookOpen,
  "Movies & TV": Clapperboard,
  Cooking: ChefHat,
  Photography: Camera,
  Fashion: Shirt,
  "Working out": Dumbbell,
  Anime: Tv,
  "Hiking & outdoors": Mountain,
  Coding: Code2,
  Dance: Music2,
  Skateboarding: PersonStanding,
  Volunteering: HeartHandshake,
} as const satisfies Record<MentorInterestOption, LucideIcon>;

export function getInterestIcon(interest: string): LucideIcon {
  if (interest in INTEREST_ICONS) {
    return INTEREST_ICONS[interest as MentorInterestOption];
  }
  return Sparkles;
}
